<template>
  <el-dialog title :show-close="false" :visible.sync="value.filtersVisible" width="50%">
    <template v-slot:title>
      <h3>Update Additional Questions</h3>
    </template>
    <template>
      <el-form ref="form" :model="regoQsAnswers" :rules="rules" label-position="top" :key="key" class="aq-form">
      <el-row :gutter="20">
        <el-col :span="24" v-for="q in additionalQs" :key="q._id">
          <!-- Input -->
          <div v-if="q.type === 1 && checkVisibility(q)" class="form-item-container">
            <el-input-title :required="q.required"><span v-html="urlify(q.question)"></span></el-input-title>
            <el-form-item :prop="q.metaField | metaProp">
              <el-input :disabled="!q.allowEdit && get(q, 'isFromManagement', false) === false" v-model="regoQsAnswers[q.metaField]" placeholder="Type here..."/>
            </el-form-item>
          </div>
          <div class="form-item-container" v-if="q.type === 2 && checkVisibility(q)">
            <!-- Dropdown -->
            <el-input-title :required="q.required"><span class="break-word" v-html="urlify(q.question)"></span></el-input-title>
            <el-form-item :prop="q.metaField | metaProp">
              <el-select :disabled="!q.allowEdit && get(q, 'isFromManagement', false) === false" class="full-width" v-model="regoQsAnswers[q.metaField]" placeholder="Select" clearable @change="updateChildValues(q)" :multiple="q.multiDropdownSelect|| checkIfMultiple(q.metaField)">
                <el-option
                  v-for="{ value } in q.meta.options"
                  :key="value"
                  :label="value"
                  :value="value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="q.isParentQs && q.parentsDependentQsList">
            <el-col :span="24" v-for="c in q.parentsDependentQsList[0].children" :key="c._id">
              <div class="mt-05 ml-15" v-if="checkChildVisibility(c, q.parentsDependentQsList[0])">
                <!-- Input -->
                <div v-if="c.type === 1">
                  <el-input-title :required="c.required"><span v-html="urlify(c.question)"></span></el-input-title>
                  <el-form-item :prop="camelCase(c.fieldName) | metaProp">
                    <el-input class="mt-05" v-model="regoQsAnswers[camelCase(c.fieldName)]" placeholder="Type here..."/>
                  </el-form-item>
                </div>

                <!-- Dropdown -->
                <div v-else-if="c.type === 2">
                  <el-input-title :required="c.required"><span v-html="urlify(c.question)"></span></el-input-title>
                  <el-form-item :prop="camelCase(c.fieldName) | metaProp">
                    <el-select class="w-100 mt-05" v-model="regoQsAnswers[camelCase(c.fieldName)]" placeholder="Select" clearable :multiple="c.multiDropdownSelect || checkIfMultiple(camelCase(c.fieldName))">
                      <el-option
                        v-for="({ value }, i) in c.meta.options"
                        :key="value"
                        :label="value"
                        :value="value"
                      >
                        {{ value }}
                        <el-dropdown @click.native.stop v-if="c.meta.descriptions && c.meta.descriptions[i].value">
                          <span class="el-dropdown-link">
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-alert
                              title="Description"
                              type="info"
                              :closable="false"
                              effect="dark">
                              {{ c.meta.descriptions[i].value }}
                            </el-alert>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <!-- File Upload -->
                <div v-else-if="c.type === 3">
                  <el-input-title :required="c.required">{{ c.question || 'Your entity requires a file to be uploaded' }}</el-input-title>
                  <h5 class="mt-05"><i class="el-icon-info"></i> Files must be 10mb or less</h5>
                  <el-upload
                    :headers="uploadHeaders"
                    :accept="accept"
                    :limit="get(c, 'meta.fileLimit', 1)"
                    :file-list="getFileList(c)"
                    :before-upload="(file) => beforeUpload(file, c)"
                    :on-error="onError"
                    :before-remove="beforeRemoveAQ"
                    :on-remove="onRemoveAQ"
                    action=""
                    :on-change="(file) => handleChangeAQ(file, c)"
                    :auto-upload="false"
                    :on-exceed="onExceed"
                    :disabled="getUploadExpiry() || !c.allowEdit"
                  >
                    <el-button class="mt-0" size="medium" type="secondary">Click to upload</el-button>
                  </el-upload>
                </div>

                <!-- NSWISA PPC Form -->
                <div v-else-if="c.type === 1001">
                  <PPCForm :formItemProp="camelCase(c.fieldName) | metaProp" v-model="regoQsAnswers[camelCase(c.fieldName)]" :disabled="!c.allowEdit"/>
                </div>
              </div>
            </el-col>
            </div>
          <div class="form-item-container" v-if="q.type === 3 && checkVisibility(q)">
            <!-- File Upload -->
            <el-input-title :required="q.required">{{ q.question || 'Your entity requires a file to be uploaded' }}</el-input-title>
            <h5 class="mt-2"><i class="el-icon-info"></i> Files must be 10mb or less</h5>
            <el-upload
              class="file-upload"
              :headers="uploadHeaders"
              :accept="accept"
              :limit="get(q, 'meta.fileLimit', 1)"
              :file-list="getFileList(q)"
              :before-upload="(file) => beforeUpload(file, q)"
              :on-error="onError"
              :before-remove="beforeRemoveAQ"
              :on-remove="onRemoveAQ"
              action=""
              :on-change="(file) => handleChangeAQ(file, q)"
              :auto-upload="false"
              :on-exceed="onExceed"
              :disabled="getUploadExpiry() || (!q.allowEdit && get(q, 'isFromManagement', false) === false)"
            >
              <el-button class="mt-0" size="medium" type="secondary">Click to upload </el-button>
            </el-upload>
          </div>
          <!------- National Special Types ------>
          <div class="form-item-container" v-if="q.type === 1001 && checkVisibility(q)">
            <!-- NSWISA PPC Form -->
            <PPCForm :formItemProp="q.metaField | metaProp" v-model="regoQsAnswers[q.metaField]" :disabled="!q.allowEdit && get(q, 'isFromManagement', false) === false"/>
          </div>
        </el-col>
      </el-row>
    </el-form>
    </template>
    <template v-slot:footer>
      <el-button @click="clearAnswer">Cancel</el-button>
      <el-button type="primary" @click="saveAnswer" >Save</el-button>
    </template>
  </el-dialog>
</template>
<script>
import _ from 'lodash';
import moment from 'moment-timezone';

// import { urlify, calculateMemberAge } from '@/utils/helpers';
import { urlify } from '@/utils/helpers';

import {
  errormsg,
} from '@/utils/constants';
import aqsFileUploadMixin from '@/mixins/aqs-file-upload';
// eslint-disable-next-line import/no-unresolved
import PPCForm from './PPCForm.vue';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.input_option };

export default {
  props: {
    value: {
      type: Object,
    },
    entity: {
      type: String,
    },
    registration: {
      type: Object,
    },
    eventData: {
      type: Object,
    },
  },
  components: {
    PPCForm,
  },
  data() {
    return {
      get: _.get,
      camelCase: _.camelCase,
      key: 0,
      urlify,
      memberTypes: undefined,
      isType3: false,
      additionalQForm: {
        selectedMember: {
          name: undefined,
          detail: undefined
        },
        selectedQuestion: undefined,
      },
      regoQsAnswers: undefined,
      filesUploaded: [],
      additionalQuestion: {},
      selectedQuestions: [],
      event: {},
      additionalQs: [],
      rules: {

      },
      isUpdateQuestions: true,
    };
  },
  mixins: [aqsFileUploadMixin],
  mounted() {
    console.log('value', this.value);
    this.generateAQs(this.value);
  },
  methods: {
    checkIfMultiple(metaField) {
      const valAnswer = _.get(this.value, `registration.meta[${metaField}]`);
      if (_.isArray(valAnswer)) {
        return true;
      }
      return false;
    },
    getUploadExpiry() {
      console.log('value', this.value);
      console.log('eventData', this.eventData);
      const { entityType } = this.value.registration;
      if (entityType === 'event') {
        const [event] = this.value.registration.event;
        const { regoEndDate, isActive } = event;
        if (moment().valueOf() <= regoEndDate && isActive) return false;
        console.log('isExpired', moment().valueOf() > regoEndDate);

        return true;
      }
      return false;
    },
    getFileList(q) {
      const filesUploaded = this.filesUploaded.filter((f) => f.meta.additionalQuestion === q.fieldName);
      return filesUploaded.map((file) => ({
        name: file.displayName ? `${file.displayName} (Uploaded At: ${this.dateFormatter(file.createdAt)})` : `${file.fileName} (Uploaded At: ${this.dateFormatter(file.createdAt)})`,
        url: file.path,
        registrationId: file.meta.registrationId,
        type: file.fileType,
        _id: file._id,
        createdAt: file.createdAt,
      }));
    },
    generateAQs(val) {
      let filterAll;
      const productType = _.get(val, 'registration.productType');
      if (val.entityType === 'indv') {
        // const { dob, gender } = val.registration.member.profile;
        // const age = calculateMemberAge(dob, this.endOfYear);
        // const filterAgeAndGender = (e) => age >= e.ageFrom && age <= e.ageTo && (e.gender === gender || e.gender === 'All' || !e.gender || (e.gender === 'Other' && (gender !== 'Male' || gender !== 'Female')));
        // const { memberType } = val.registration;
        // if (productType) filterAll = (e) => _.includes(e.productTypes, productType) && _.includes(e.memberTypes, memberType) && filterAgeAndGender(e);
        if (productType) filterAll = (e) => e; // removed filter because we are getting directly from the registration
      } else if (productType) filterAll = (e) => e; // removed filter because we are getting directly from the registration
      // } else if (productType) filterAll = (e) => _.includes(e.productTypes, productType);
      this.regoQsAnswers = _.cloneDeep(_.get(val, 'registration.meta'));
      this.filesUploaded = _.filter(_.cloneDeep(_.get(this, 'value.registration.files')), (f) => f.meta.additionalQuestion !== 'PPC Form');

      // this.$store.commit('loading', { loading: true, text: 'Loading...' });
      // this.$http.get(`assemble/api/v1/admin/events/${this.$route.params.id}/additional-questions`).then((response) => {
      // const entityType = _.get(val, 'registration.entityType', 'event');
      // const { additionalQs } = val.registration[entityType][0];
      const { additionalQs } = val.registration?.event?.[0] || val.registration?.membership?.[0] || [];
      this.additionalQs = val.registration.meta ? _.filter(additionalQs, (q) => filterAll(q)) : [];
      const hasMeta = !!this.regoQsAnswers;
      _.forEach(this.additionalQs, (q) => {
        const metaField = _.camelCase(q.fieldName);
        // eslint-disable-next-line
            q.metaField = metaField;
        // eslint-disable-next-line
            if (q.required) this.$set(this.rules, `${metaField}`, defaultRequiredRule);
        if (!hasMeta) {
          this.$set(
            this.regoQsAnswers,
            metaField,
            q.type === 3 ? [] : undefined // If it's a file upload initialize an array;
          );
        } else if (hasMeta) {
          if (q.type === 3) {
            this.$set(
              this.regoQsAnswers,
              metaField,
              this.regoQsAnswers[metaField] ? this.regoQsAnswers[metaField] : []
            );
          }
        }
      });
      console.log('aqs', this.additionalQs);
    },
    beforeRemoveAQ(file) {
      return this.$confirm(`Are you sure you want to remove ${ file.name } ?`, 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
    },
    onRemoveAQ(file) {
      if (!file.response && !file.name) return;
      // const { name } = file.response || file;
      const fileId = file._id;

      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.delete(`/assemble/api/v1/portal/files/${fileId}`)
        .then(() => {
          this.$store.commit('loading', false);
          this.$message.success('File deleted successfully');
          // filter out file from file list
          this.filesUploaded = this.filesUploaded.filter((f) => f._id !== fileId);
          this.$emit('updateFiles', { files: this.filesUploaded, regoId: this.value.registration._id });
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
          this.$store.commit('loading', false);
        });
    },
    async handleChangeAQ(file, q) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      // const fieldName = _.camelCase(q.fieldName);
      const {
        _id, entityId, entityType, productType
      } = this.value.registration;
      const { _id: memberId } = this.value.registration.member;
      try {
        this.$store.commit('loading', true);
        const fileType = file.raw.name.split('.')[file.raw.name.split('.').length - 1];
        const res = await this.$http.post('/assemble/api/v1/portal/files/get-presigned-url', {
          fileName: file.name,
          fileType,
          registrationId: _id,
          additionalQuestion: q.fieldName,
          entityId,
          entityType,
          memberId,
          productType: productType === 'team' ? 'team' : 'individual',
          type: 'additional-question',
        });
        const { url, fileId, insert } = res.data.data;
        await fetch(url, {
          method: 'PUT',
          body: file.raw,
          headers: { 'Content-Type': '*/*' },
        });
        // eslint-disable-next-line no-param-reassign
        file._id = fileId;
        // eslint-disable-next-line no-param-reassign
        file.name = `${file.name} (Uploaded At: ${this.dateFormatter(this.moment())})`;
        this.filesUploaded.push(insert);
        this.$emit('updateFiles', { files: this.filesUploaded, regoId: this.value.registration._id });
        // const uploads = _.get(this, `regoQsAnswers.${fieldName}`);
        // this.$set(this.regoQsAnswers, fieldName, uploads.concat({ fileName: name }));
      } catch (e) {
        this.$message.error('There has been an error');
      }
      return this.$store.commit('loading', false);
    },
    updateChildValues(q) {
      if (q.isParentQs && q.parentsDependentQsList) {
        _.forEach((q.parentsDependentQsList[0].children), (c) => {
          // eslint-disable-next-line no-unused-expressions
          this.$set(this.regoQsAnswers, _.camelCase(c.fieldName), '');
        });
      }
    },
    checkIfParent(id) {
      const { additionalQs } = this;

      const find = (array = [], _id) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const question of array) {
          if (question.parentsDependentQsList) {
            // eslint-disable-next-line no-restricted-syntax
            for (const q of question.parentsDependentQsList) {
              if (q._id === _id) return true;
            }
          }
        }

        return false;
      };

      const found = find(additionalQs, id);
      if (found) return true;

      return false;
    },
    dateFormatter(timestamp) {
      return this.moment(timestamp).format('DD/MM/YYYY HH:mm');
    },
    showDisplayName(fileName) {
      const nameWithHash = fileName.split('.')[0].split('-');
      const displayName = nameWithHash.slice(0, nameWithHash.length - 1).join(' ');
      return displayName;
    },
    checkChildVisibility(question, parentQuestion) {
      const allAnswers = this.regoQsAnswers;
      const childQuestion = this.visibleQuestions.find((qs) => qs._id === parentQuestion._id);
      if (!childQuestion) return false;
      console.log('childQuestion', childQuestion);
      console.log('parentQuestion', parentQuestion);

      // Skip duplicate questions - if this is the first child (level 2) and has the same question as a parent question
      if (question.level === 2 && question.question === parentQuestion.question) {
        console.log('here1');
        return false;
      }

      // Handle multiple answers (array) case for the first condition check
      const fieldNameValue = allAnswers[_.camelCase(childQuestion.fieldName)];
      if (Array.isArray(fieldNameValue)) {
        // For arrays, check if any value matches any condition
        const hasMatch = fieldNameValue.some((value) => _.includes(parentQuestion.condition, value));
        if (!hasMatch) return false;
      } else if (!_.includes(parentQuestion.condition, fieldNameValue)) {
        return false;
      }

      if (question.level === 2 && childQuestion) {
        const parentAnswer = allAnswers[childQuestion.metaField];
        console.log('parernnt ans', parentAnswer);

        // Handle multiple answers for level 2 questions
        if (Array.isArray(parentAnswer)) {
          return parentAnswer.some((value) => _.includes(parentQuestion.condition, value));
        }
        return _.includes(parentQuestion.condition, parentAnswer);
      }

      const getLastQuestion = parentQuestion.children.find((p) => p.level === question.level - 1);
      if (getLastQuestion) {
        const parentAnswer = allAnswers[_.camelCase(getLastQuestion.fieldName)];
        // Handle multiple answers for nested levels
        if (Array.isArray(parentAnswer)) {
          return parentAnswer.some((value) => _.includes(getLastQuestion.condition, value));
        }
        return _.includes(getLastQuestion.condition, parentAnswer);
      }
      return false;
    },
    checkVisibility(q) {
      // First check if it's a regular question (not a parent or child)
      if (!q.isParentQs && !q.isDependentQs) {
        if (q.type === 3) {
          this.isType3 = true;
        }
        return true;
      }

      // If it's a parent question with a dependent question list
      if (q.isParentQs && q.parentsDependentQsList) {
        if (q.type === 3) {
          this.isType3 = true;
        }

        // Hide parent question if it has children (show only the child version)
        if (q.parentsDependentQsList[0]?.children?.length > 0) {
          return false;
        }

        // Special case: If the parentsDependentQsList refers to another question
        const referencedId = q.parentsDependentQsList[0]?._id;
        if (referencedId) {
          const referencedQuestion = this.additionalQs.find((qs) => qs._id === referencedId);
          if (referencedQuestion) {
            const referencedField = _.camelCase(referencedQuestion.fieldName);
            const referencedAnswer = this.regoQsAnswers[referencedField];

            // Check if the selected answer matches any of the conditions
            if (Array.isArray(referencedAnswer)) {
              return q.parentsDependentQsList.some((dep) => referencedAnswer.some((value) => _.includes(dep.condition, value)));
            }

            return q.parentsDependentQsList.some((dep) => _.includes(dep.condition, referencedAnswer));
          }
        }

        return true;
      }

      // If we get here, this is likely a dependent question
      // Handle any other cases
      if (q.type === 3) {
        this.regoQsAnswers[q.metaField] = [];
        this.isType3 = false;
      } else {
        this.$set(this.regoQsAnswers, q.metaField, undefined);
      }

      return false;
    },
    clearAnswer() {
      this.$emit('closeDialog', true);
      // this.value.filtersVisible = false;
    },
    showQuestionMessage() {
      this.$alert('Additional Question details that will be retrieve', 'Question List', {
        confirmButtonText: 'OK'
      });
    },
    saveAnswer() {
      this.$refs.form.validate((valid) => {
        const verifyUpload = this.verifyUploadsAQ(this.isType3);
        if (valid && verifyUpload) {
          const regoId = this.value.registration._id;
          let isFilled = true;
          _.forEach(this.regoQsAnswers, (value, key) => {
            if (value === undefined || value === '') {
              delete this.regoQsAnswers[key];
            }
            if (key === 'ppcForm') {
              if (Object.keys(value).length > 0) {
                isFilled = _.some(Object.keys(value), (k) => value[k] !== '');
              }
            }
          });
          if (!isFilled) {
            return this.$message.error('Please fill in the PPC form');
          }
          const { entityId, entityType } = this.value.registration;
          const oldPPC = this.value.registration.meta.ppcForm;
          const newPPC = this.regoQsAnswers.ppcForm;
          const isSame = _.isEqual(oldPPC, newPPC);
          const PPCEdited = !isSame;
          let PPCUploadedIds = [];
          if (!isSame) {
            PPCUploadedIds = _.filter((_.get(this, 'value.registration.fileUploads')), (f) => f.meta.additionalQuestion === 'PPC Form').map((f) => f._id);
          }
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.put(`assemble/api/v1/portal/entity/${entityId}/registrations/${regoId}/update-answer`, {
            productType: this.value.entityType, // indv(include indv and indv-to-team) or team
            entityType,
            additionalQs: this.additionalQs,
            meta: this.regoQsAnswers,
            PPCEdited,
            PPCUploadedIds
          }).then((res) => {
            this.$message.success('Successful');
            this.value.filtersVisible = false;
            if (res.data.data) {
              this.$emit('updateMeta', { meta: res.data.data.meta, regoId });
            }
            this.$store.commit('loading', false);
          }).catch((error) => {
            this.$message.error(error.response.data.message);

            this.$store.commit('loading', false);
          });
        }
        return true;
      });
    },
    verifyUploadsAQ() {
      const mandatory = this.value.registration.additionalQs.filter((q) => q.type === 3 && q.required);
      if (mandatory.length) {
        const invalid = mandatory.filter((q) => {
          const fieldName = _.camelCase(q.fieldName);
          if (!this.regoQsAnswers[fieldName]) {
            return true;
          }
          if (this.regoQsAnswers[fieldName].length === 0) {
            return true;
          }

          return (this.regoQsAnswers[fieldName] && this.regoQsAnswers[fieldName].uploaded === false);
        });
        if (invalid.length) {
          this.$message.error(`You need to complete the following file upload(s): ${invalid.map((f) => f.question)}`);
          return false;
        }
      }
      return true;
    },

  },
  computed: {
    endOfYear() {
      return this.$store.getters['national/endOfYear'];
    },
    visibleQuestions() {
      const allQuestions = this.additionalQs;
      const allAnswers = this.regoQsAnswers;
      return allQuestions.filter((q) => {
        const { parentsQsList, isDependentQs } = q;
        if (!isDependentQs) return true;
        return parentsQsList.some((parent) => {
          const parentQ = allQuestions.find((qs) => qs._id === parent._id);
          if (!parentQ) return false;
          const parentAnswer = allAnswers[parentQ.metaField];
          return _.includes(parent.condition, parentAnswer);
        });
      });
    },
  },
  filters: {
    metaProp(val) {
      return `${val}`;
    }
  },
  watch: {
    // eslint-disable-next-line
    'value': {
      deep: true,
      handler(val) {
        if (val.registration) {
          this.generateAQs(val);
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
/* General form styling */
.aq-form {
  width: 100%;
  max-width: 100%;
}

.form-item-container {
  margin-bottom: 16px;
  width: 100%;
}

.child-item {
  margin-left: 20px;
}

.full-width {
  width: 100%;
}

.file-upload {
  width: 100%;
}

/* Ensure Element UI form components take full width */
::v-deep .el-form-item {
  width: 100%;
  margin-bottom: 16px;
}

::v-deep .el-form-item__content {
  width: 100%;
  display: block;
}

::v-deep .el-input,
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-input__inner {
  width: 100%;
  box-sizing: border-box;
}

::v-deep .el-select .el-input {
  width: 100%;
}

/* Make labels break words properly */
::v-deep .el-input-title,
::v-deep .el-form-item__label {
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  white-space: normal;
}

/* File upload styling */
::v-deep .el-upload {
  width: 100%;
}

::v-deep .el-upload-list {
  width: 100%;
}

::v-deep .el-upload-list__item {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Safari-specific fixes */
@media not all and (min-resolution:.001dpcm) {
  @supports (-webkit-appearance:none) {
    .full-width {
      width: 100% !important;
      display: block;
    }

    ::v-deep .el-select {
      display: block;
      width: 100% !important;
    }
  }
}
</style>
